(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/init.js');
"use strict";


const _React = React,
  Fragment = _React.Fragment;
svs.ticket_gifts.init = async () => {
  var _svs$utils$url$queryS;
  const PlayerRouter = svs.app.ReactRouter.PlayerRouter;
  const Route = svs.app.ReactRouter.Route;
  const baseUrl = svs.core.data.baseUrl;
  const ManualRedeem = svs.ticket_gifts.manualRedeem.components.ManualRedeem;
  const Redeem = svs.ticket_gifts.redeem.components.Redeem;
  const Barcode = svs.ticket_gifts.barcode.components.Barcode;
  const UnavailableTicket = svs.ticket_gifts.redeem.components.unavailableTicket.UnavailableTicket;
  const GameLauncherWrapper = svs.ticket_gifts.redeem.components.GameLauncherWrapper;
  const AsyncRoute = svs.ticket_gifts.redeem.components.AsyncRoute;
  const chooseGameForVoucher = svs.ticket_gifts.chooseGameForVoucher;
  const getVouchers = svs.ticket_gifts.utils.getVouchers;
  const _svs$ticket_gifts$uti = svs.ticket_gifts.utils.campaign,
    ids = _svs$ticket_gifts$uti.ids,
    campaignMappings = _svs$ticket_gifts$uti.campaignMappings,
    _svs$ticket_gifts$uti2 = _svs$ticket_gifts$uti.ids,
    _svs$ticket_gifts$uti3 = _svs$ticket_gifts$uti2 === void 0 ? {} : _svs$ticket_gifts$uti2,
    LYCKOPLATSEN = _svs$ticket_gifts$uti3.LYCKOPLATSEN;
  const giftCode = location.pathname.split('/')[2];
  const extraGiftCodes = (_svs$utils$url$queryS = svs.utils.url.queryString.koder) === null || _svs$utils$url$queryS === void 0 ? void 0 : _svs$utils$url$queryS.split(',');
  let campaign = svs.utils.url.queryString.utm_campaign;
  const campaignId = svs.utils.url.queryString.campaignId;
  const campaignOverride = svs.utils.url.queryString.kampanj;
  if (campaignId && campaignMappings[campaignId]) {
    campaign = campaignMappings[campaignId];
  }
  if (campaignOverride && campaignMappings[campaignOverride]) {
    campaign = campaignMappings[campaignOverride];
  }
  if (campaign && !Object.values(ids).includes(campaign)) {
    campaign = undefined;
  }
  let voucherData;
  let extraVouchersData;
  try {
    if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      voucherData = await getVouchers(giftCode);
      extraGiftCodes && (extraVouchersData = await Promise.all(extraGiftCodes.map(code => getVouchers(code))));
      if (extraVouchersData && extraVouchersData.length !== 0) {
        voucherData.vouchers = [...voucherData.vouchers, ...extraVouchersData.flatMap(data => data.vouchers)];
      }
      if (campaign === LYCKOPLATSEN) {
        voucherData.personalGreeting = "Vars\xE5god ".concat(svs.core.userSession.getUser().firstName);
        if (voucherData.vouchers.length === 3) {
          voucherData.personalMessage = React.createElement(Fragment, null, "H\xE4r finns dina tre lotter.", React.createElement("br", null), "Du v\xE4ljer sj\xE4lv \u2013 skrapa alla", React.createElement("br", null), "direkt eller ta en i taget.");
        } else {
          voucherData.personalMessage = '';
        }
      }
    }
  } catch (e) {
    if (e.code === '26 102' || e.code === '26 3') {
      window.location.href = "".concat(svs.core.data.baseUrl, "?err=").concat(giftCode);
      return;
    }
    return svs.tur.apierrors.showErrorMessage({
      response: e.code,
      onConfirm: () => {
        window.location.href = svs.core.data.baseUrl;
      }
    });
  }
  const getActiveVouchers = (voucherData, voucherIndex, voucherCode) => [...voucherData.vouchers.slice(voucherIndex), ...voucherData.vouchers.slice(0, voucherIndex)].filter(v => v.state === 'ACTIVE' && v.voucherId !== voucherCode).sort((a, b) => Boolean(chooseGameForVoucher(b)) - Boolean(chooseGameForVoucher(a))); 

  ReactDOM.render(React.createElement(PlayerRouter, {
    basename: baseUrl,
    withRouter: true
  }, React.createElement(Route, {
    component: ManualRedeem,
    exact: true,
    path: "/"
  }), React.createElement(Route, {
    component: _ref => {
      let history = _ref.history,
        match = _ref.match;
      const ticketsSearchParams = svs.utils.paramHandler.get({
        key: 'tickets'
      });
      const priceSearchParams = svs.utils.paramHandler.get({
        key: 'price'
      });
      let numberOfTickets = ticketsSearchParams.key && Number(ticketsSearchParams.value) || 0;
      const totalPrice = priceSearchParams.key && Number(priceSearchParams.value) || 0;
      if (campaign === LYCKOPLATSEN) {
        var _voucherData;
        numberOfTickets = numberOfTickets || ((_voucherData = voucherData) === null || _voucherData === void 0 || (_voucherData = _voucherData.vouchers) === null || _voucherData === void 0 ? void 0 : _voucherData.length) || (extraGiftCodes === null || extraGiftCodes === void 0 ? void 0 : extraGiftCodes.length) + 1 || 0;
      }
      return React.createElement(Redeem, {
        campaign: campaign,
        history: history,
        isPlayer: svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER),
        match: match,
        numberOfTickets: numberOfTickets,
        totalPrice: totalPrice,
        voucherData: voucherData
      });
    },
    exact: true,
    path: "/:giftCode"
  }), React.createElement(Route, {
    component: _ref2 => {
      let match = _ref2.match,
        history = _ref2.history;
      return React.createElement(AsyncRoute, {
        key: match.params.voucherCode,
        todo: done => {
          const voucherCode = match.params.voucherCode;
          if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
            return svs.components.customer_login.login({
              returnNewCustomer: true,
              returnUrl: "".concat(window.location.pathname).concat(window.location.search),
              extraParams: {
                gift: true
              }
            });
          }
          const voucherIndex = _.findIndex(voucherData.vouchers, v => v.voucherId === voucherCode);
          const voucher = voucherData.vouchers[voucherIndex];
          const ticketInfo = chooseGameForVoucher(voucher);
          const skinId = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.normalizeSkinId(voucher.ticketPosition);
          const activeVouchers = getActiveVouchers(voucherData, voucherIndex, voucherCode);
          const nextVoucher = activeVouchers[0];
          const wagerId = svs.utils.paramHandler.get({
            key: 'wagerId'
          }).value;
          const onClose = e => {
            var _voucherData2;
            e === null || e === void 0 || e.preventDefault();
            if (((_voucherData2 = voucherData) === null || _voucherData2 === void 0 || (_voucherData2 = _voucherData2.vouchers) === null || _voucherData2 === void 0 ? void 0 : _voucherData2.length) === 1) {
              window.location.href = "".concat(svs.core.urlMapping.get('myBetsHome'));
            } else {
              window.location.href = "".concat(svs.core.urlMapping.get('ticketGiftHome'), "/").concat(voucherCode);
            }
          };
          if (!ticketInfo) {
            done(() => React.createElement(UnavailableTicket, {
              history: history,
              voucher: voucher
            }));
          } else if (!wagerId || wagerId.toLowerCase() === 'PENDING') {
            voucher.state = 'CLAIMED';
            svs.utils.paramHandler.set({
              key: 'wagerId',
              value: 'PENDING'
            });
            done(() => React.createElement(GameLauncherWrapper, {
              history: history,
              match: match,
              nextVoucher: nextVoucher,
              onClose: onClose,
              receiverSameAsBuyer: voucherData.receiverSameAsBuyer,
              skinId: skinId,
              ticketInfo: ticketInfo,
              voucherCode: voucherCode
            }));
          } else {
            voucher.state = 'CLAIMED';
            done(() => React.createElement(GameLauncherWrapper, {
              history: history,
              isPurchaseDisabled: true,
              match: match,
              nextVoucher: nextVoucher,
              onClose: onClose,
              receiverSameAsBuyer: voucherData.receiverSameAsBuyer,
              ticketInfo: ticketInfo,
              wagerId: wagerId
            }));
          }
        }
      });
    },
    exact: true,
    path: "/:giftCode/spela/:voucherCode"
  }), React.createElement(Route, {
    component: _ref3 => {
      var _voucherData3;
      let giftCode = _ref3.match.params.giftCode,
        history = _ref3.history;
      let nextVoucher = null;
      let availableOnline = false;
      const ticketsSearchParams = svs.utils.paramHandler.get({
        key: 'tickets'
      });
      const priceSearchParams = svs.utils.paramHandler.get({
        key: 'price'
      });
      const manual = svs.utils.paramHandler.get({
        key: 'manual'
      });
      svs.utils.paramHandler.remove({
        key: 'manual'
      });
      let numberOfTickets = ticketsSearchParams.key && Number(ticketsSearchParams.value) || 0;
      let totalPrice = priceSearchParams.key && Number(priceSearchParams.value) || 0;
      if ((_voucherData3 = voucherData) !== null && _voucherData3 !== void 0 && _voucherData3.vouchers) {
        var _voucherData4, _voucherData5, _voucherData6;
        const voucherIndex = _.findIndex((_voucherData4 = voucherData) === null || _voucherData4 === void 0 ? void 0 : _voucherData4.vouchers, v => v.voucherId === giftCode);
        const activeVouchers = getActiveVouchers(voucherData, voucherIndex, giftCode);
        nextVoucher = activeVouchers && activeVouchers[0];
        availableOnline = ((_voucherData5 = voucherData) === null || _voucherData5 === void 0 ? void 0 : _voucherData5.vouchers) && chooseGameForVoucher((_voucherData6 = voucherData) === null || _voucherData6 === void 0 ? void 0 : _voucherData6.vouchers[voucherIndex]);
      }
      if (campaign === LYCKOPLATSEN) {
        var _voucherData7, _voucherData8;
        numberOfTickets = numberOfTickets || ((_voucherData7 = voucherData) === null || _voucherData7 === void 0 || (_voucherData7 = _voucherData7.vouchers) === null || _voucherData7 === void 0 ? void 0 : _voucherData7.length) || (extraGiftCodes === null || extraGiftCodes === void 0 ? void 0 : extraGiftCodes.length) + 1 || 0;
        totalPrice = totalPrice || ((_voucherData8 = voucherData) === null || _voucherData8 === void 0 || (_voucherData8 = _voucherData8.vouchers) === null || _voucherData8 === void 0 ? void 0 : _voucherData8.reduce((acc, voucher) => acc + Number.parseInt(voucher.value, 10), 0)) || 0;
      }
      return React.createElement(Barcode, {
        availableOnline: availableOnline,
        extraGiftCodes: extraGiftCodes,
        giftCode: giftCode,
        history: history,
        manual: Boolean(JSON.parse(manual && manual.value)),
        nextVoucher: nextVoucher,
        numberOfTickets: numberOfTickets,
        totalPrice: totalPrice
      });
    },
    exact: true,
    path: "/:giftCode/streckkod"
  })), document.getElementById('reactContainer'));
};
svs.ticket_gifts.init();

 })(window);